export const getShowBrokenDiscountHandling = ({ isUnifiedDashboard, allowsBrokenDiscountHandling }) => {
  if (isUnifiedDashboard) return true

  return allowsBrokenDiscountHandling
}
